import React from 'react';

interface Props {
    label: string;
    htmlFor: string;
    required?: boolean;
    children: React.ReactNode;
    extendedClassName?: string;
    error?: boolean;
}

const FormRow = (props: Props) => {
    const { label, htmlFor, required, children, error } = props;

    const defaultClassName = 'flex flex-row gap-4 items-center';
    const errorClassName = error ? 'text-red-700' : '';
    const formRowClassNames = [defaultClassName, errorClassName, props.extendedClassName].join(' ');

    return (
        <div className={formRowClassNames}>
            <label className="w-3/12 font-normal" htmlFor={htmlFor}>
                {label}
                {required && <span className="text-red-600">*</span>}
            </label>
            <div className="w-9/12">{children}</div>
        </div>
    );
};

export default FormRow;
